export default __webpack_public_path__ + "static/media/seo-call.893f4fc3.mp3";